export const NoResultsTag = ({
  width = 16,
  height = 16,
  viewBox = '0 0 16 16',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <g clip-path="url(#clip0_40010942_51655)">
        <path
          d="M5.00065 5.33398C5.18475 5.33398 5.33398 5.18475 5.33398 5.00065C5.33398 4.81656 5.18475 4.66732 5.00065 4.66732C4.81656 4.66732 4.66732 4.81656 4.66732 5.00065C4.66732 5.18475 4.81656 5.33398 5.00065 5.33398Z"
          fill="#0E0E12"
        />
        <path
          d="M8.39132 1.72465C8.14133 1.47459 7.80224 1.33406 7.44865 1.33398H2.66732C2.3137 1.33398 1.97456 1.47446 1.72451 1.72451C1.47446 1.97456 1.33398 2.3137 1.33398 2.66732V7.44865C1.33406 7.80224 1.47459 8.14133 1.72465 8.39132L7.52732 14.194C7.83033 14.4951 8.24015 14.6641 8.66732 14.6641C9.09449 14.6641 9.50431 14.4951 9.80732 14.194L14.194 9.80732C14.4951 9.50431 14.6641 9.09449 14.6641 8.66732C14.6641 8.24015 14.4951 7.83033 14.194 7.52732L8.39132 1.72465Z"
          stroke="#0E0E12"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.00065 5.33398C5.18475 5.33398 5.33398 5.18475 5.33398 5.00065C5.33398 4.81656 5.18475 4.66732 5.00065 4.66732C4.81656 4.66732 4.66732 4.81656 4.66732 5.00065C4.66732 5.18475 4.81656 5.33398 5.00065 5.33398Z"
          stroke="#0E0E12"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_40010942_51655">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
